import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

const styles = {
  button: {
    marginTop: '1em'
  }
};

const BalanceButton = ({ classes }) => {
    const search = useLocation().search;
    const balanceShow = new URLSearchParams(search).get("balanceShow");
    let history = useHistory();
    return (
        <Button
            className={[{marginLeft: "10px"}]}
            label={(balanceShow !== "true") ? "Mostrar balance" : "Esconder balance"}
            title={(balanceShow !== "true") ? "Mostrar balance" : "Esconder balance"}
            onClick={() => {
                if (balanceShow === "true") {
                    history.push(`/transactions?${search.slice(1).replace("balanceShow=true", "balanceShow=false")}`)
                } else {
                    if (search.includes("balanceShow")) {
                        history.push(`/transactions?${search.slice(1).replace("balanceShow=false", "balanceShow=true")}`)    
                    }
                    else if (search.includes("?")) {
                        history.push(`/transactions?${search.slice(1)}&balanceShow=true`)
                    } else {
                        history.push(`/transactions?balanceShow=true`)
                    }
                }
            }}
        >
        </Button>
    )
};

export default withStyles(styles)(BalanceButton);
